// extracted by mini-css-extract-plugin
export default {"list":"styles_list__fsQP6","listItemPresent":"styles_listItemPresent__KDTLk","text":"styles_text__79DqV","listItemNotPresent":"styles_listItemNotPresent__VmACl"};